isMultiplePlaylistsPage